<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="model.pkid ? '编辑' : '新建'"
      width="600px"
      @close="$reset('form')">
    <el-form 
        ref="form"
        v-loading="contentLoading" 
        :model="model" 
        :rules="ruleValidate" 
        class="form" 
        label-width="80px">
      <el-form-item label="序号" prop="functionIndex">
        <el-input v-model="model.functionIndex" placeholder="请输入序号"/>
      </el-form-item>
      <el-form-item label="菜单编码" prop="functionNO">
        <el-input v-model="model.functionNO" placeholder="请输入菜单编码"/>
      </el-form-item>
      <el-form-item label="菜单名称" prop="functionName">
        <el-input v-model="model.functionName" placeholder="请输入菜单名称"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        model: {
          pkid: 0,
          functionIndex: "",
          functionNO: "",
          functionName: "",
          parentID: "",
        },
        ruleValidate: {
          functionNO: { required: true, message: "请输入菜单编码", trigger: "blur" },
          functionName: { required: true, message: "请输入菜单名称", trigger: "blur" },
        },
      };
    },
    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        if (row) {
          if (mark) {
            this.getData(row.id);
          } else {
            this.model.parentID = row.id;
          }
        }
      },

      getData(id) {
        this.contentLoading = true;
        this.$http
          .get("basic", `functions/${id}`)
          .then((resp) => {
            if (resp.success) {
              this.model = resp.data;
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "functions", this.model)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.model.pkid) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
